var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "notes" } },
    [
      !!_vm.notes.length
        ? _c(
            "div",
            { attrs: { id: "visitor-notes" } },
            _vm._l(_vm.notes, function (note, index) {
              return _c("div", { key: index, staticClass: "item" }, [
                _c("div", { staticClass: "name-date" }, [
                  _c("div", { staticClass: "agent-name" }, [
                    _vm._v(_vm._s(note.createdUser.name)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                    }",
                        },
                      ],
                      staticClass: "date",
                      attrs: {
                        content: _vm.$moment(note.createdAt).format("LLL"),
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$moment(note.createdAt).fromNow()) +
                          "\n                "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "agent-note" }, [
                  _vm._v(_vm._s(note.description)),
                ]),
              ])
            }),
            0
          )
        : _c("div", { staticClass: "empty-notes-container" }, [
            _c("div", { staticClass: "empty-notes-content" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "empty-notes-message" }, [
                _vm._v(_vm._s(_vm.$t("visitor.notUserData"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "empty-notes-description" }, [
                _vm._v("Bu kişiye ait henüz not eklenmemiş."),
              ]),
            ]),
          ]),
      _vm._v(" "),
      _vm.isModalVisible
        ? _c(
            "div",
            {
              staticClass: "custom-visitor-notes-modal-overlay",
              on: { click: _vm.handleCancel },
            },
            [
              _c(
                "div",
                {
                  staticClass: "custom-visitor-notes-modal",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "custom-visitor-notes-modal-header" },
                    [
                      _c("h3", [_vm._v(_vm._s(_vm.$t("message.addNote")))]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "custom-visitor-notes-modal-close-button",
                          on: { click: _vm.handleCancel },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("close"),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "custom-visitor-notes-modal-body" },
                    [
                      _c("div", { staticClass: "note-form" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.description,
                              expression: "description",
                            },
                          ],
                          staticClass: "non-resizable",
                          attrs: { placeholder: _vm.$t("message.addUserNote") },
                          domProps: { value: _vm.description },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.description = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "note-form-actions",
                            staticStyle: { display: "none" },
                          },
                          [
                            _c(
                              "a-checkbox",
                              {
                                model: {
                                  value: _vm.isPrivate,
                                  callback: function ($$v) {
                                    _vm.isPrivate = $$v
                                  },
                                  expression: "isPrivate",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("message.privateNote")))]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "custom-visitor-notes-modal-footer" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "custom-visitor-notes-modal-cancel-button",
                          on: { click: _vm.handleCancel },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("message.cancel")) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "custom-visitor-notes-modal-ok-button",
                          on: { click: _vm.handleOk },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("message.send")) +
                              "\n                "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-tooltip",
        { attrs: { placement: "topLeft" } },
        [
          _c("template", { slot: "title" }, [
            _c("span", [_vm._v("Not Oluştur")]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "add-attribute-button",
              on: { click: _vm.showModal },
            },
            [_c("span", { staticClass: "material-icons" }, [_vm._v("add")])]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-notes-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("note_alt")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }